<template>
    <div>
      <footer class="footer">
        <div class="row text-center footer__primary p-5">
          <div class="col-lg-4 col-sm-6 col-xs-6">
            <ul class="footer__primary-list ps-0">
              <li class="footer__link-margin" v-for="(link, index) in primaryLinks" :key="index">
                <router-link class="footer__link link" :to="link.path">{{ link.name }}</router-link>
              </li>
            </ul>
          </div>
  
          <div class="col-lg-4 col-sm-6 col-xs-6">
            <ul class="footer__primary-list ps-0">
              <li class="footer__link-margin" v-for="(link, index) in secondaryLinks" :key="index">
                <router-link class="footer__link link" :to="link.path">{{ link.name }}</router-link>
              </li>
            </ul>
          </div>
  
          <div class="col-lg-4 col-sm-12 col-xs-12 footer__media container">
            <div class="justify-content-center py-3">
              <a v-for="(social, index) in socialLinks" :key="index" class="footer__link my-3" :href="social.url">
                <i class="footer__link-fontsize" :class="social.iconClass"></i>
              </a>
            </div>
          </div>
        </div>
  
        <div class="container__waves">
          <div>
            <svg class="container__waves-waves" xmlns="http://www.w3.org/2000/svg" viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
              <defs>
                <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
              </defs>
              <g class="parallax">
                <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
                <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
              </g>
            </svg>
          </div>
        </div>
  
        <div class="row footer__secondary my-3">
          <div class="col-lg-4 footer__secondary-legal py-3 my-3">
            <router-link class="footer__link text-start ms-4 px-2 link" to="/privacy-policy">Privacy Policy</router-link> |
            <router-link class="footer__link px-2 link" to="/legal-policy">Legal</router-link>
          </div>
          <div class="col-lg-8 footer__secondary-copyright my-3">
            <p class="pt-3 mx-2">&copy; 2023 INTELLIGENT QUOTING TECHNOLOGY S.L. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  export default {
    name: "AppFooter",
    data() {
      return {
        primaryLinks: [
          { name: "Home", path: "/" },
          { name: "Coverage", path: "/coverage" },
          { name: "Services", path: "/services" },
          { name: "Partner Center", path: "/partner-center" },
          { name: "Cases", path: "/cases" },
          { name: "Testimonials", path: "/testimonials" }
        ],
        secondaryLinks: [
          { name: "Events", path: "/events-gallery" },
          { name: "Blogs", path: "/blogFile" },
          { name: "Contact Us", path: "/contact" },
          { name: "Global NSOC", path: "/global-nsoc" },
          { name: "Sitemap", path: "/sitemap" },
          { name: "About Us", path: "/about-us" }
        ],
        socialLinks: [
          { url: "https://twitter.com/BITSBYTEGLOBAL", iconClass: "fab fa-twitter px-3" },
          { url: "https://www.facebook.com/bitsandbyteglobal", iconClass: "fab fa-facebook-f px-3" },
          { url: "https://www.linkedin.com/company/bitsandbyteglobal/", iconClass: "fab fa-linkedin-in px-3" },
          { url: "https://www.instagram.com/bitsandbyteglobal/", iconClass: "fab fa-instagram px-3" }
        ]
      };
    }
  };
  </script>
  
  <style>
@import "../assets/css/AppFooter.css"; 
</style>
  